<header #headerRoot [class.active]="stick">
  <app-topbar></app-topbar>
  <div #stickyHeader class="top-nav top-header sticky-header">
    <div class="container-fluid-lg">
      <div class="row">
        <div class="col-12">
          <div class="navbar-top">
            <div class="d-xl-none d-inline"></div>
            <a [routerLink]="['/']" class="web-logo nav-logo">
              <picture>
                <source srcset="assets/logo/header3.webp" type="image/webp">
                <img src="assets/logo/header3.png" class="img-fluid logo" alt="{{ 'auto_logo' | translate }}" width="448" height="62" />
              </picture>
            </a>

            <app-ds-navbar
              class="header-quick-links d-none d-lg-flex"
              [sticky]="false"
              [embedded]="true"
              [showBrand]="false"
              [mobileMenuLabel]="'auto_atalhos_principais' | translate"
              [items]="getQuickLinkItems((isAuthenticated$ | async) ?? false)"
            ></app-ds-navbar>

            <div class="rightside-box">
              <ul class="right-side-menu">
                <li class="right-side"></li>

                <li class="right-side"></li>
                <li class="right-side">
                  <div class="onhover-dropdown header-badge">
                    <app-header-cart></app-header-cart>
                  </div>
                </li>
                <li class="right-side onhover-dropdown">
                  <app-my-account></app-my-account>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="sticky-spacer" aria-hidden="true"></div>
</header>
